import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { useQuery } from "@tanstack/react-query";

type UseRecipientMessagesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    recipientType?: string
    providerKlass?: string
    sentAtGt?: string
    sentAtLt?: string
    recipientId?: string
    clientCompanyId?: string
    establishmentCompanyId?: string
    status?: string
  };
  mapper?: (data: any) => T,
};

export const useRecipientMessages = <T,>({
  filters: {
    search = '',
    page,
    recipientType,
    providerKlass,
    sentAtGt,
    sentAtLt,
    recipientId,
    clientCompanyId,
    establishmentCompanyId,
    status
  } = {},
  mapper = Mapper.default<T>(),
}: UseRecipientMessagesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: [
      'recipientMessages',
      search,
      page,
      recipientType,
      providerKlass,
      sentAtGt,
      sentAtLt,
      recipientId,
      clientCompanyId,
      establishmentCompanyId,
      status
    ],
    queryFn: () => {
      return privateAxios.get(`/notifications/recipient_messages/notifications`, {
        params: {
          search,
          page,
          'q[recipient_type_eq]': recipientType,
          'q[provider_klass_eq]': providerKlass,
          'q[sent_at_gteq]': sentAtGt,
          'q[sent_at_lteq]': sentAtLt,
          'q[recipient_id_eq]': recipientId,
          'q[client_company_id_eq]': clientCompanyId,
          'q[establishment_company_id_eq]': establishmentCompanyId,
          'q[status_eq]': status,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
  });

  return { data, meta, ...rest };
};
